import React, { useState, useEffect } from "react";

// components

import About from "../components/AboutUs/About.js";
import Navbar from "../components/Navbar/Navbar";


export default function AboutUs() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const menuToggle = () => {
        setIsMenuOpen(!isMenuOpen);
    };
  return (
    
    <>
            <Navbar />
            {/* <Sidebar
                linksData={menuDataHome}
                isMenuOpen={isMenuOpen}
                menuToggle={menuToggle}
            /> */}
          <About/>
    </>
  );
}